import { Instagram } from '@components/instagram/models';
import { Block } from '@shared/models';

export const instagramMock: Block<Instagram> = {
  type: 'instagram',
  data: {
    title: {
      text: `Des cuisines qui génèrent + de likes [[que vos influenceurs préférés]]`,
      as: 'span',
    },
    hashtag: '#socooc',
  },
};
